<template>
  <div class="nav-top">
    <b-navbar toggleable="lg" type="dark" variant="info" :class="dataClass">
      <b-navbar-toggle @click="navToggle" :class="{close:isclose}" target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav ref="a">
        <b-navbar-nav>
          <b-nav-item class="pc-nav" href="#about">About hunicorn</b-nav-item>
          <b-nav-item class="pc-nav" href="#contact">Contact us</b-nav-item>
          <!-- <b-nav-item class="pc-nav" href="#">Language</b-nav-item> -->

          <b-nav-item
            @click="navToggle"
            v-for="(item,index) in mNav"
            :key="index"
            class="m-nav"
            :class="activeIndex==index?'light':''"
            :href="item.href"
          >{{item.name}}</b-nav-item>

          <div class="nav-bar">
            <b-nav-item href="http://rate.cn-hunicorn.com/Weixin/Price/WeixinLogin">Rate</b-nav-item>
            <!-- <b-nav-item href="#">OA</b-nav-item> -->
            <b-nav-item class="cls" href="#" @click="handleClsClick"></b-nav-item>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "navTop",
  data() {
    return {
      screenWidth: 0,
      isclose: false,
      mNav: [
        { href: "#home", name: "Home" },
        { href: "#about", name: "About" },
        { href: "#business", name: "Main" },
        { href: "#distribution", name: "Market" },
        { href: "#contact", name: "Contact" }
      ]
    };
  },
  props: {
    dataClass: String,
    activeIndex: Number
  },
  methods: {
    navToggle() {
      this.isclose = !this.$refs.a.show;
    },
    handleClsClick() {
      this.$router.push('/login');
    }
  },
  mounted() {}
};
</script>


<style scoped>
.nav-top {
  /* float: right; */
  position: fixed;
  top: 45px;
  right: 45px;
  z-index: 99;
}
.nav-top ul {
  overflow: hidden;
  display: block;
  line-height: 14px;
}
.nav-top ul li {
  float: left;
  margin-right: 30px;
}
.nav-top ul a {
  font-size: 18px;
}
.nav-top .pc-nav {
  display: block;
}
.nav-top .m-nav {
  display: none;
}
.white .navbar-nav .nav-link {
  color: #f4f4f4;
}
.black .navbar-nav .nav-link {
  color: #444;
}
.nav-mobile {
  width: 40px;
  height: 40px;
  /* background: none; */
  border: none;
  display: none;
}
.cls a {
  display: inline-block;
  width: 32px;
  height: 32px;
  background: url(../assets/cls.png) no-repeat;
  background-size: cover;
}
.bg-info {
  background: none !important;
}
.nav-bar {
  float: left;
}
.white .navbar-nav .nav-link:hover,
.white .navbar-nav .nav-link:focus {
  color: #f4f4f4;
}
.black .navbar-nav .nav-link:hover,
.black .navbar-nav .nav-link:focus {
  color: #444;
}

@media screen and (max-width: 992px) {
  .navbar-dark .navbar-toggler {
    border: none;
    position: absolute;
    outline: none;
    right: 20px;
    top: 20px;
  }
  .nav-top ul li {
    padding: 15px 0;
  }
  .navbar {
    position: fixed;
    width: 100%;
    left: 0;
    top: 0;
    background: #091439 !important;
    text-align: center;
    padding: 0;
  }
  .navbar-nav {
    padding: 100px 0 500px 0;
  }
  .nav-top .m-nav {
    display: block;
    float: none;
    margin: 0;
  }
  .nav-top .pc-nav {
    display: none;
  }
  .nav-bar {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    padding-top: 100px;
  }
  .nav-top ul li {
    margin: 0;
  }
  .navbar .navbar-nav .nav-link {
    color: #fff;
    opacity: 0.5;
  }
  .navbar .navbar-nav .light a {
    opacity: 1;
  }
  .navbar .navbar-nav .nav-bar a {
    opacity: 1;
  }
  .navbar .navbar-nav .nav-bar li {
    padding: 20px;
    background: url(../assets/line.png) no-repeat right;
  }
  .navbar .navbar-nav .nav-bar .cls {
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavTop.vue